export const appInit = state => state.servant.appInit
export const isGuest = state => state.servant.isGuest
export const getError = state => state.servant.error
export const getLoginStatus = state => state.servant.loginStatus
export const getRegisterStatus = state => state.servant.registerStatus
export const getSaveCodeStatus = state => state.servant.saveCodeStatus
export const getToken = state => state.servant.token